/**
 * Freshness cap for the customer's entitlements: auth/me (plan, feature allowance) and the
 * Capabilities API. Both change on the Old Platform or by sysadmin with no event to this app, so
 * their caches are bounded rather than `Infinity`. Once older than this they are refetched on the
 * next mount or tab refocus; a `useAuthMe` and a `useCustomerCapabilities` observer stay mounted
 * app-wide so the refocus refetch always runs.
 */
export const ENTITLEMENTS_STALE_TIME = 60_000;
